var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcSoundon = function SvgIcSoundon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.4 6.8 6.5-4.1c.5-.3 1.1 0 1.1.6v17.3c0 .6-.6.9-1.1.6l-6.5-4.1c-.3 0-.4-.3-.4-.5V7.4c0-.2.1-.5.4-.6zM.7 17h2.5c.5 0 .8-.3.8-.7V7.7c0-.4-.3-.7-.7-.7H.7c-.4 0-.7.3-.7.7v8.5c0 .5.3.8.7.8zm19-12.7-.5.5c-.3.3-.3.7 0 1 1.5 1.7 2.5 3.9 2.5 6.2 0 2.4-.9 4.5-2.5 6.2-.3.3-.3.8 0 1l.5.5c.3.3.8.3 1.1 0 2-2.1 3.2-4.8 3.2-7.7 0-3-1.2-5.7-3.2-7.7-.3-.3-.8-.3-1.1 0zm.1 7.7c0-1.8-.7-3.5-1.8-4.8-.3-.3-.8-.4-1.1-.1l-.5.5c-.3.3-.3.7-.1 1 .8 1 1.2 2.1 1.2 3.4 0 1.3-.5 2.4-1.2 3.4-.2.3-.2.7.1 1l.5.5c.3.3.8.3 1.1-.1 1.1-1.3 1.8-3 1.8-4.8z"
  })));
};
export default SvgIcSoundon;